import useQueryParams from './useQueryParams';

export const useUpdateChainQueryParam = (
  defaultValue?: string,
  notAll?: boolean,
  key = 'chain',
) => {
  const [cs, setChain] = useQueryParams<string>(
    key,
    (defaultValue ?? (notAll ? 'eth' : '')) as string,
  );
  return [cs, setChain] as const;
};
